module.exports = __webpack_public_path__ + "img/customerleft_img.758bf14a.jpeg";